// extracted by mini-css-extract-plugin
export var fallback = "_7-0";
export var icon = "_7-1";